"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const colors_1 = __importDefault(require("../../styles/colors"));
const styles_1 = __importDefault(require("../../styles/styles"));
const icon_1 = __importDefault(require("../icon/icon"));
const metricsCardStyles_1 = __importDefault(require("./metricsCardStyles"));
const MetricsCard = ({ label, text, icon }) => {
    return (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, metricsCardStyles_1.default.card, styles_1.default.flexDirectionRow] },
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexTwo },
            react_1.default.createElement(react_native_paper_1.Title, { style: [styles_1.default.textColorWhite] }, label),
            react_1.default.createElement(react_native_paper_1.Title, { style: [styles_1.default.textColorWhite] }, text)),
        react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.alignCenterEnd] },
            react_1.default.createElement(icon_1.default, { icon: icon, color: colors_1.default.WHITE, size: 40 }))));
};
exports.default = MetricsCard;
